import React, { useEffect, useState } from "react";
import BackgroundImage from "../../assets/images/img/SIGNUP-BG.png";
import LoginImg from "../../assets/images/img/login.png";
import Button from "../Common/Button";
import { useNavigate, Link } from "react-router-dom";
import useNetworkServices from "../../Networking/baseAPIManager";
import { HeaderLogo } from "./HeaderLogo";
import { Toastify } from "../Common/Toastify";

const OTPVerification = () => {
  const otpLength = 4;
  const initialTime = 2 * 60; // 1 minute in seconds
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(initialTime);
  const [otp, setOtp] = useState(Array(otpLength).fill(""));
  const [isExpired, setExpired] = useState(false);
  const { OTPVerification, ResendOTP } = useNetworkServices();
  const [formData, setFormData] = useState({ email: "" });
  const [error, setError] = useState("");
  const [type, setType] = useState("info");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [disable, setDisable] = useState(false);
  const [otpdisable, setOTPDisable] = useState(false);
  useEffect(() => {
    const email = localStorage.getItem("forgotPasswordEmail");
    if (email) {
      setFormData({ email });
    }

    const savedExpiryTime = localStorage.getItem("otpExpiryTime");
    if (savedExpiryTime) {
      const timeRemaining = Math.floor((savedExpiryTime - Date.now()) / 10000);
      if (timeRemaining > 0) {
        setSeconds(timeRemaining);
        setExpired(false);
      } else {
        setSeconds(0);
        setExpired(true);
      }
    } else {
      const expiryTime = Date.now() + initialTime * 1000;
      localStorage.setItem("otpExpiryTime", expiryTime);
    }
    const timer = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          clearInterval(timer);
          setExpired(true);
          localStorage.removeItem("otpExpiryTime");
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [initialTime, !isExpired]);

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < otpLength - 1 && value) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        const prevInput = document.getElementById(`otp-${index - 1}`);
        if (prevInput) {
          prevInput.focus();
        }
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isExpired) {
      setError("");
      return;
    }
    if (disable) return;
    const otpCode = otp.join("");
    const data = { ...formData, otp: otpCode };
    setDisable(true);
    try {
      const response = await OTPVerification(data);
      console.log(response.data, "ResponseData");
      if (response.data.success) {
        const otpToken = response.data.otpToken;
        navigate("/newpassword", { state: { otpToken } });
        setType("success");
        setMessage(
          error?.response?.data?.message ||
            "Oops! Something went wrong. Please try again."
        );
        setShow(true);
        console.log(otpToken, "otpToken");
      } else {
        setError("Fill the Blank Otp");
      }
    } catch (error) {
      setType("error");
      setMessage(
        error?.response?.data?.message ||
          "Oops! Something went wrong. Please try again."
      );
      setShow(true);
      console.error("Sign-in error:", error);
      setError("An error occurred. Please try again.");
    } finally {
      setDisable(false);
    }
  };

  const handleResendOtp = async () => {

    if(otpdisable) return ; 

    setOTPDisable(true)
    try {
      const response = await ResendOTP(formData);
      console.log("OTP resent successfully:", response.data);
      setOtp(Array(otpLength).fill("")); 
      const expiryTime = Date.now() + initialTime * 10000;
      localStorage.setItem("otpExpiryTime", expiryTime);
      setSeconds(initialTime);
      setExpired(false);
      setType("success");
      setMessage(
        response?.data?.message ||
          "Oops! Something went wrong. Please try again."
      );
      setShow(true);
    } catch (error) {
      setType("error");
      setMessage(
        error?.response?.data?.message ||
          "Oops! Something went wrong. Please try again."
      );
      setShow(true);
      console.error("Error resending OTP:", error);
    }finally{
      setOTPDisable(false)
    }
  };
  return (
    <>
      <div
        className="flex items-center justify-center min-h-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <Toastify type={type} message={message} show={show} setShow={setShow} />
        <Link to="/">
          <HeaderLogo />
        </Link>
        <div className="container p-8 mt-28 lg:m-0 md:m-0">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 md:col-span-6 lg:col-span-6 flex items-center justify-center">
              <div className="bg-white rounded-lg shadow md:mt-0 sm:max-w-lg xl:p-0 dark:bg-white dark:border-gray-700">
                <div className="p-8 space-y-3 md:space-y-6 sm:p-8">
                  <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-gray-800">
                    OTP Verification
                  </h1>
                  <p className="text-gray-400 text-sm">
                    Please enter the OTP sent to your email to verify your
                    account.
                  </p>
                  {error && <p className="text-red-500 text-sm">{error}</p>}
                  <form onSubmit={handleSubmit}>
                    <div className="flex flex-col space-y-8">
                      <div className="flex flex-row items-center justify-between mx-auto w-full">
                        {Array.from({ length: otpLength }).map((_, index) => (
                          <div key={index} className="w-16 h-16">
                            <input
                              className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                              type="text"
                              name={`otp-${index}`}
                              id={`otp-${index}`}
                              maxLength="1"
                              value={otp[index]}
                              onChange={(e) => handleChange(e, index)}
                              onKeyDown={(e) => handleKeyDown(e, index)}
                            />
                          </div>
                        ))}
                      </div>

                      <div className="flex flex-col space-y-5">
                        {isExpired ? (
                          <p className="text-red-500">
                            OTP has expired. Please request a new one.
                          </p>
                        ) : (
                          <p>
                            Time remaining: {Math.floor(seconds / 60)}:
                            {String(seconds % 60).padStart(2, "0")}
                          </p>
                        )}
                        <div>
                          <Button
                            type="submit"
                            disabled={disable}
                            className={`bg-[#E73921] w-full text-white font-bold py-2 px-4 rounded hover:bg-[#e56554fc] focus:ring-2 focus:ring-red-300 transition duration-300 
                              ${
                                disable ? "opacity-50 cursor-not-allowed" : ""
                              } `}
                            text={disable ? "Processing..." : "Verify Account"}
                          />
                        </div>

                        <div className="flex flex-col items-center text-center text-sm font-medium space-y-1 text-gray-500">
                          <div className="flex pt-3">
                            <p className="pe-2">Didn't receive code?</p>
                            <button
                              type="button"
                             
                              className={`flex flex-row items-center text-blue-600 font-bold
                                ${
                                  !isExpired || otpdisable ? "opacity-50 cursor-not-allowed" : ""
                                } `}
                              onClick={handleResendOtp}
                              disabled={!isExpired}
                            >
                            {  otpdisable ? "Processing..." : "Resend OTP"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-6 flex items-center justify-center">
              <img src={LoginImg} alt="Login" className="max-w-full h-auto" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OTPVerification;
